import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { organizationApi } from '../api/organizationApi';
import type { UpdateOrganizationSettingsData } from '../types';
import { toast } from 'react-hot-toast';
import { AxiosError } from 'axios';

export const useOrganizationSettings = () => {
  return useQuery({
    queryKey: ['organizationSettings'],
    queryFn: organizationApi.getSettings,
  });
};

export const useUpdateOrganizationSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateOrganizationSettingsData) =>
      organizationApi.updateSettings(data),
    onSuccess: () => {
      toast.success('Settings updated successfully');
      queryClient.invalidateQueries({ queryKey: ['organizationSettings'] });
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error.response?.data?.message || 'Failed to update settings');
    },
  });
};
